import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';

class StatStore extends ReduceStore {

    getInitialState() {
        return Map();
    }

    get(key) {
        return this.getState().get(key);
    }

    has(key) {
        return this.getState().has(key);
    }
    
    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.STATS_INFO_REQUEST:
                if (action.payload.hasOwnProperty('default') && action.payload.default !== undefined) {
                    return this.getState().set(action.payload.key, action.payload.default);
                }
                return state;
                
            case ActionTypes.STATS_INFO_SUCCESS:
                return this.getState().set(action.payload.key, action.data);
                
            default:
                return state;
        }
    }
}

export default new StatStore(CentricDispatcher);
